<template>

  <popup
      v-if="isManager('project|finance|maintenance|admin|management')"

      button-style="info"
      heading="Progress Workflow"
     :show-text="showText"
     :button-size="buttonSize"
     button-text="Add Progress"
     button-icon="fa fa-cogs"
     :disable-save="false"
     :disable-button="!isManager('project|finance|maintenance|admin|management') || readOnly"
     @save="onSaveDialog"
     @close="onCloseDialog">

    <Progress-detail
      ref="PRG"
      :owner-id="ownerId"
      :site-id="siteId"
      :editMode="true"
      :adding="true"
      :hide-panel="true"
    />

  </popup>

</template>


<script>

import ProgressDetail from '@/components/progress/ProgressDetail'

export default {

  components: {
    ProgressDetail
  },

  props: {

    siteId: {
      type: Number,
      default: null
    },

    ownerId: {
      type: Number,
      default: null
    },

    showText: {
      type: Boolean,
      default: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    buttonSize: {
      type: String,
      default: 'small'
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    onSaveDialog () {
      this.$refs.ad.onSave()
      this.$emit('update-stats')
    },


    onCloseDialog () {
      this.$refs.ad.onClose()
      this.$emit('update-stats')
    }

  },


  data () {
    return {
      btnSize: this.buttonSize,
    }
  }

}

</script>
